import { UserManager } from 'oidc-client-ts'
import { SPARKY_FRAMEWORK } from '../init/initConst'
import { getOidcConfig } from '../framework/oidcConfig'
import { getRootElement } from '../framework/loadingMask'
import type { SparkySettings } from '../framework/microAppTypes'
import type { FrameworkVars } from '../framework/stateTypes'

const render = (settings: SparkySettings) => {
  const fxVars = settings.variables[SPARKY_FRAMEWORK] as FrameworkVars
  const config = getOidcConfig(fxVars)
  if (config) {
    const manager = new UserManager(config)
    manager.signinSilentCallback().catch((err) => {
      console.error('Silent authentication failed:', err)
    })
  }
  else {
    console.error('OIDC configuration not found. Silent authentication cannot be performed.')
  }
  const rootEl = getRootElement()
  if (rootEl) {
    rootEl.textContent = 'Authenticating...'
  }
}

export default render
